import { mapUrlToPageLogProps, Page } from 'components/Logs'
import Main from './ClientsMain'
import New from './ClientsNew'
import Show from './ClientsShow'
import EditData from './ClientsEditData'
import EditAddress from './ClientsEditAddress'

export default {
  Main,
  New,
  Show,
  EditData,
  EditAddress,
  Logs: mapUrlToPageLogProps(({ params }) => ({
    title: 'Cliente',
    entity: 'customer',
    entityId: params.clientId,
  }))(Page),
}
